export default {
    page_title: "Kevi | Campos do orçamento",
    title: "Campos do orçamento",
    add_button: "Adicionar",
    back_button: "Voltar",
    save_button: "Salvar",
    create_form_title: "Criando campo",
    field_form: {
        name_label: "Nome",
        type_label: "Tipo",
    },
    tooltips: {
        edit_field: "Editar campo",
        delete_field: "Excluir campo",
    },
    delete_modal: {
        title: "Gostaria de excluir",
        body_standard:
            "Esta ação é irreversível, tem certeza que deseja continuar?",
        body_linked: "Este campo está vinculado",
        automations: "as seguintes automações:",
        segments: "aos seguintes segmentos:",
        warning:
            "É recomendado ajustar antes de remover, continuar agora pode gerar resultados inesperados.",
    },
    edit_modal: {
        title: "Gostaria de editar o nome para",
        body: "Certifique-se de que o novo nome está correto antes de confirmar.",
    },
    notifications: {
        added: "Campo adicionado",
        deleted: "Campo de orçamento excluído",
        edited: "Campo de orçamento editado",
    },
};
